import DateInput from "components/Input/DateInput";
import { formatDate } from "helpers";
import { useEffect, useState } from "react";

export interface DateProps {
  val?: string;
  options?: any;
  row: any;
  colKey: string;
  onChange: (item: any, options?: any) => void;
  withBorder?: boolean;
}
export default function DateComp({ val, options, colKey, row, onChange, withBorder }: DateProps) {
  const [value, setValue] = useState<string | null | undefined>(val);
  useEffect(() => {
    setValue(val);
  }, [val]);

  function handleChange(date: any) {
    let res = { ...row };
    res[colKey] = formatDate(date);
    onChange(res, { row });
    setValue(formatDate(date));
  }

  if (options && options.editable) {
    return (
      <DateInput
        label=""
        name={colKey}
        onchange={handleChange}
        defaultValue={value}
        style={{ inputWrapper: { ...(!withBorder && { border: "none" }) } }}
      />
    );
  }
  return <div>{value}</div>;
}
